import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WebflowLoginPage } from './webflow-login.page';

const routes: Routes = [
  {
    path: '',
    component: WebflowLoginPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebflowLoginPageRoutingModule {}
